<div class="AmBagsPayment-content">
  <div class="AmBagsPayment-item" *ngFor="let item of listBagsPayments">
    <span>{{item.count}}</span>
    <img class="opacity-75" src="./assets/images/bags/icon-bag-trash.svg">
    <span>{{item.label | translate}}</span>
    <img class="bags-check" src="./assets/images/bags/icon-bag-check.svg">
  </div>
</div>
